import { styleConstants, themeConstants } from '@paywithextend/components'
import { spacing } from 'ext-ui/style/spacing'
import { font_size_lg } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  .ChurnSurveyModal-reasons {
    display: flex;
    flex-direction: column;
    gap: ${spacing(3)};
    margin-top: -16px; // reduce 40px container gap to ~24px between subtitle and radio list
  }

  .ChurnSurveyModal-option {
    display: flex;
    align-items: center;
    gap: ${spacing(2)};
    padding: ${spacing(4)};
    border: 1px solid ${styleConstants.colors.gray_medium};
    border-radius: 10px;
    cursor: pointer;
    background-color: ${styleConstants.colors.white};

    &:hover {
      border-color: ${styleConstants.colors.gray_dark};
    }

    &.is-selected {
      border-color: ${themeConstants.colors.cta};
    }

    &:focus-visible {
      outline: 2px solid ${themeConstants.colors.cta};
      outline-offset: 2px;
    }
  }

  .ChurnSurveyModal-option-label {
    font-size: ${font_size_lg};
    color: ${themeConstants.colors.font_primary};
  }

  .ChurnSurveyModal-inline-free-text {
    padding: ${spacing(1)} 0;

    .label {
      color: ${styleConstants.colors.gray_darkest};
      font-size: 14px;
    }
  }

  .ChurnSurveyModal-additional-comment {
    .label {
      color: ${themeConstants.colors.font_primary};
    }

    .label-field {
      font-size: ${font_size_lg};
    }

    textarea {
      min-height: 80px !important; // ~3 lines, override autoResize inline style
    }
  }
`
